module.exports = __webpack_public_path__ + "static/media/code.676117ae.jpg";